// Generated by ts-to-zod
import { z } from 'zod';

export const automationDatapointSchema = z.object({
  id: z.string(),
  count: z.number(),
  confidenceMean: z.number(),
  automation: z.number(),
});
